import { cn } from '../../utils/cn';
import { eggReadinessOptions } from '../../data/eggData';
import * as Icons from 'lucide-react';

interface EggReadinessSelectorProps {
  options: typeof eggReadinessOptions;
  selected: typeof eggReadinessOptions[0];
  onSelect: (option: typeof eggReadinessOptions[0]) => void;
  disabled?: boolean;
}

const EggReadinessSelector = ({ 
  options, 
  selected, 
  onSelect,
  disabled = false
}: EggReadinessSelectorProps) => {
  return (
    <div className="w-full">
      <h3 className="font-display text-xl text-gray-800 font-semibold mb-4 text-center">
        Select Egg Readiness
      </h3>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {options.map((option) => {
          const IconComponent = Icons[option.icon as keyof typeof Icons];
          
          return (
            <button
              key={option.id}
              className={cn(
                "flex flex-col items-center p-4 rounded-xl border-2 transition-all duration-200",
                "hover:bg-primary-50 hover:border-primary-300",
                selected.id === option.id 
                  ? "border-primary-500 bg-primary-50 shadow-md" 
                  : "border-gray-200 bg-white",
                disabled && "opacity-60 cursor-not-allowed"
              )}
              onClick={() => !disabled && onSelect(option)}
              disabled={disabled}
              aria-pressed={selected.id === option.id}
            >
              <div className="w-16 h-16 mb-2 rounded-full bg-gray-100 flex items-center justify-center">
                <IconComponent className="w-8 h-8 text-primary-500" />
              </div>
              <span className="font-medium text-gray-800">{option.name}</span>
              <span className="text-sm text-gray-500">{option.displayTime}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EggReadinessSelector;